/**
 * DrManiLoadingScreen - auto-advancing loading interstitial before the email gate.
 * Mirrors the USCN quiz loading card with animated progress bar.
 */
import React from 'react';

interface DrManiLoadingScreenProps {
  caption: string;
  title: string;
  subtitle?: string | undefined;
  description?: string | undefined;
}

const DrManiLoadingScreen: React.FC<DrManiLoadingScreenProps> = ({
  caption,
  title,
  subtitle,
  description,
}) => (
  <div className="dmm-loading-screen">
    <div className="dmm-loading-card">
      <span className="dmm-loading-caption">{caption}</span>
      <h1 className="dmm-loading-title">{title}</h1>
      {subtitle && <span className="dmm-loading-subtitle">{subtitle}</span>}
      {description && <p className="dmm-loading-copy">{description}</p>}
      <div className="dmm-loading-bar">
        <div className="dmm-loading-bar-fill" />
      </div>
    </div>
  </div>
);

export default DrManiLoadingScreen;
